// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-code-container[data-v-3541763a]{margin-top:50px}.common-code-container .title[data-v-3541763a]{margin-bottom:20px;font-size:22px;font-family:OpenSans-Bold,sans-serif}.common-code-container .description[data-v-3541763a]{margin-bottom:14px;font-size:14px;color:#5e6d82;font-family:OpenSans,sans-serif}.common-code-container .common-code-content[data-v-3541763a]{padding:24px;border:1px solid #ebebeb;border-radius:3px}", ""]);
// Exports
module.exports = exports;
